import { GetLinks } from "../../../config";

export default [
  {
    key: "/funnel-360",
    icon: <i className="ki-outline ki-chart-line-star fs-1 " />,
    label: GetLinks("/funnel-360", "Funnel 360"),
  },
];
